import React from "react";
import { ButtonV2 } from "../../../ButtonV2";
export const ButtonSection = ({ buttonLabel, buttonOpenInNewTab, buttonHref, linkLabel, linkHref, linkButtonDesign, linkClassName, linkIcon, showArrowRight }) => {
    const linkDesign = (() => linkButtonDesign || "ghost-large-wbg")();
    const linkCSSClassName = (() => {
        let CSSClass = linkButtonDesign ? "" : "login-button";
        if (linkClassName) {
            CSSClass += ` ${linkClassName}`;
        }
        return CSSClass;
    })();
    return (React.createElement(React.Fragment, null,
        buttonLabel && buttonHref && (React.createElement(ButtonV2, { classes: "tmx25-round-green-lightgreen btn-height-adjustment-for-extra-large", href: buttonHref, openInNewTab: buttonOpenInNewTab, showArrowRight: showArrowRight }, buttonLabel)),
        linkLabel && linkHref && (React.createElement(ButtonV2, { design: linkDesign, classes: linkCSSClassName, href: linkHref, openInNewTab: buttonOpenInNewTab, icon: linkIcon }, linkLabel))));
};
